/** [CurveBeamAI] Session state for web-connect - mirrors develop branch */
export enum SessionConnectionStateEnum {
  PENDING = 'PENDING',
  CONNECTED = 'CONNECTED',
  DISCONNECTED = 'DISCONNECTED',
}
